import { IUpdateLeadDataDto } from "../../../../services/caju/interfaces/iUpdateLeadDataDto";
import { IStep3FormValues } from "../useStep3Form/iStep3FormValues";
import { calculateProductMappings } from "../productsList/productMapping";

export function getDtoFromStep3FormValues(
  leadId: string,
  values: IStep3FormValues
) {
  const { solutions, subscriptions } = calculateProductMappings(
    values.selectedProducts
  );

  const result: IUpdateLeadDataDto = {
    externalId: leadId,
    step: "3",
    interestSubscriptionProducts: subscriptions.join(";"),
    interestSolutions: solutions.join(";"),
    isLead: true,
  };

  return result;
}
